// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-3xNno";
var _4 = "paper-nr6cN";
var _5 = "paper__fullScreen-1CEcO";
var _6 = "paper_paperScrollBody-3zrjU";
var _7 = "fullscreen-1rICv";
var _8 = "small-1mxMh";
var _9 = "paper__noPadding-2Z_3X";
var _a = "medium-2GZBX";
var _b = "large-1BZ_8";
var _c = "xlarge-bb7hA";
var _d = "top_wrapper-31sKX";
var _e = "content-2Cio_";
var _f = "dialog_container-3ynM-";
var _10 = "closeButton-P24lr";
var _11 = "swipeBlock-1yEu9";
var _12 = "swipeBlock_line-2iO_9";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "paper", _5 as "paper__fullScreen", _6 as "paper_paperScrollBody", _7 as "fullscreen", _8 as "small", _9 as "paper__noPadding", _a as "medium", _b as "large", _c as "xlarge", _d as "top_wrapper", _e as "content", _f as "dialog_container", _10 as "closeButton", _11 as "swipeBlock", _12 as "swipeBlock_line" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "paper": _4, "paper__fullScreen": _5, "paper_paperScrollBody": _6, "fullscreen": _7, "small": _8, "paper__noPadding": _9, "medium": _a, "large": _b, "xlarge": _c, "top_wrapper": _d, "content": _e, "dialog_container": _f, "closeButton": _10, "swipeBlock": _11, "swipeBlock_line": _12 }
